import { useCallback } from "react";

import type { PaymentDepositAccountInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { HOTEL_APPLICATION_DATA_QUERY } from "@/components/features/_shared/repository/hotel-application-data/query/schema";
import { START_GUIDE_QUERY } from "@/components/features/_shared/repository/start-guide/query/schema";

import { PAYMENT_DEPOSIT_ACCOUNT_MUTATION } from "./schema";

export const usePaymentDepositAccountMutation = () => {
	const { mutationFunc } = useCustomMutation(PAYMENT_DEPOSIT_ACCOUNT_MUTATION);
	const onUpdatePaymentDepositAccount = useCallback(
		async (input: PaymentDepositAccountInput) =>
			await mutationFunc({
				variables: { input },
				refetchQueries: [
					{
						query: HOTEL_APPLICATION_DATA_QUERY,
						variables: {
							hotelID: input.hotelID,
						},
					},
					{
						query: START_GUIDE_QUERY,
						variables: {
							hotelID: input.hotelID,
						},
					},
				],
			}),
		[mutationFunc],
	);

	return {
		onUpdatePaymentDepositAccount,
	};
};
